'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    cursor: pointer;\n'], ['\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    cursor: pointer;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    font-family: ', ';\n    font-weight: ', ';\n    font-size: ', ';\n    color: ', ';\n    display: flex;\n    align-items: center;\n    padding: ', 'px;\n    margin-right: ', 'px;\n    width: 47px;\n    box-sizing: border-box;\n\n    &:hover {\n        opacity: 0.8;\n    }\n'], ['\n    font-family: ', ';\n    font-weight: ', ';\n    font-size: ', ';\n    color: ', ';\n    display: flex;\n    align-items: center;\n    padding: ', 'px;\n    margin-right: ', 'px;\n    width: 47px;\n    box-sizing: border-box;\n\n    &:hover {\n        opacity: 0.8;\n    }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    margin-left: ', 'px;\n    display: inline-flex;\n    align-items: center;\n'], ['\n    margin-left: ', 'px;\n    display: inline-flex;\n    align-items: center;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    position: absolute;\n    top: 100%;\n    left: 0;\n    background: white;\n    border-radius: 2px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    z-index: 100;\n    display: ', ';\n    min-width: 47px;\n'], ['\n    position: absolute;\n    top: 100%;\n    left: 0;\n    background: white;\n    border-radius: 2px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    z-index: 100;\n    display: ', ';\n    min-width: 47px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    padding: ', 'px ', 'px;\n    font-family: ', ';\n    font-size: ', ';\n    color: ', ';\n\n    &:hover {\n        background: ', ';\n    }\n'], ['\n    padding: ', 'px ', 'px;\n    font-family: ', ';\n    font-size: ', ';\n    color: ', ';\n\n    &:hover {\n        background: ', ';\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../constants/colors');

var _text = require('../../constants/text');

var _sizes = require('../../constants/sizes');

var _getSize = require('../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _arrow = require('../../atoms/icons/arrow');

var _arrow2 = _interopRequireDefault(_arrow);

var _getScreenSize = require('../../helpers/getScreenSize');

var _getScreenSize2 = _interopRequireDefault(_getScreenSize);

var _isMobile = require('../../helpers/isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SelectWrapper = _styledComponents2.default.div(_templateObject);

var LanguageDisplay = _styledComponents2.default.div(_templateObject2, _text.TextSizes.HeaderFontFamily, _text.TextSizes.WeightSemiBold, _text.TextSizes.P2FontSize, function (_ref) {
    var color = _ref.color;
    return color || _colors.Colors.TextDark;
}, (0, _getSize2.default)(_sizes.Sizes.xxs), function (_ref2) {
    var $mobile = _ref2.$mobile;
    return $mobile ? 0 : (0, _getSize2.default)(_sizes.Sizes.md);
});

var ArrowWrapper = _styledComponents2.default.div(_templateObject3, (0, _getSize2.default)(_sizes.Sizes.xxs));

var Dropdown = _styledComponents2.default.div(_templateObject4, function (props) {
    return props.isOpen ? 'block' : 'none';
});

var Option = _styledComponents2.default.div(_templateObject5, (0, _getSize2.default)(_sizes.Sizes.xxs), (0, _getSize2.default)(_sizes.Sizes.xs), _text.TextSizes.HeaderFontFamily, _text.TextSizes.P2FontSize, _colors.Colors.TextDark, _colors.Colors.BackgroundLight);

var LanguageToggle = function LanguageToggle(_ref3) {
    var context = _ref3.context,
        color = _ref3.color;

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        isOpen = _useState2[0],
        setIsOpen = _useState2[1];

    var dropdownRef = (0, _react.useRef)(null);
    var mobile = (0, _isMobile2.default)((0, _getScreenSize2.default)());

    var currentCulture = function () {
        // First check for override
        if (context.overrideCulture) {
            return context.overrideCulture;
        }
        // Then check Redux state
        if (context.culture) {
            return context.culture;
        }
        // Then check localStorage
        var storedCulture = localStorage.getItem('preferredCulture');
        if (storedCulture) {
            return storedCulture;
        }
        // Fallback to browser preference or default
        return window.navigator.languages[0].substr(0, 2) + '-CA' || 'en-CA';
    }();

    var isEnglish = currentCulture.startsWith('en');

    var options = [{ label: 'EN', value: 'en-CA' }, { label: 'FR', value: 'fr-CA' }];

    var handleLanguageChange = function handleLanguageChange(culture) {
        context.doReduceCulture(culture);
        localStorage.setItem('preferredCulture', culture);
        setIsOpen(false);
    };

    // Ensure localStorage is in sync with current culture on component mount
    (0, _react.useEffect)(function () {
        var storedCulture = localStorage.getItem('preferredCulture');
        if (context.culture && (!storedCulture || storedCulture !== context.culture)) {
            localStorage.setItem('preferredCulture', context.culture);
        }
    }, [context.culture]);

    (0, _react.useEffect)(function () {
        var handleClickOutside = function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            return document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return _react2.default.createElement(
        SelectWrapper,
        { ref: dropdownRef, onClick: function onClick() {
                return setIsOpen(!isOpen);
            } },
        _react2.default.createElement(
            LanguageDisplay,
            { color: color, $mobile: mobile },
            isEnglish ? 'EN' : 'FR',
            _react2.default.createElement(
                ArrowWrapper,
                null,
                _react2.default.createElement(_arrow2.default, { direction: 'down', size: _sizes.Sizes.xxs })
            )
        ),
        _react2.default.createElement(
            Dropdown,
            { isOpen: isOpen },
            options.map(function (option) {
                return _react2.default.createElement(
                    Option,
                    {
                        key: option.value,
                        onClick: function onClick(e) {
                            e.stopPropagation();
                            handleLanguageChange(option.value);
                        }
                    },
                    option.label
                );
            })
        )
    );
};

exports.default = LanguageToggle;